import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail } from 'lucide-react';

const socialLinks = [
  { href: 'https://www.instagram.com/syltix.dev', label: 'Instagram', icon: <Instagram size={24} /> },
  { href: 'mailto:syltix@syltix.dev', label: 'Email', icon: <Mail size={24} /> },
];

export default function Footer() {
  return (
    <footer className="relative mt-24 py-8 pb-0 px-4 sm:px-6 lg:px-8 mb-0" style={{ marginBottom: 0, paddingBottom: 0 }}>
      <div className="relative z-10 max-w-7xl mx-auto" style={{ marginBottom: 0, paddingBottom: 0 }}>
        <div 
          className="rounded-2xl p-4 sm:p-6 md:p-8 mb-0"
          style={{
            marginBottom: 0,
            paddingBottom: 0,
            background: 'rgba(255, 255, 255, 0.12)',
            backdropFilter: 'blur(16px)',
            WebkitBackdropFilter: 'blur(16px)',
            border: '1px solid rgba(255, 255, 255, 0.25)',
            boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.1)',
          }}
        >
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8">
            {/* Social Links */}
            <div className="flex space-x-6">
              {socialLinks.map(link => (
                <a
                  key={link.href}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/90 hover:text-white transition-all duration-200 hover:scale-110"
                  aria-label={link.label}
                >
                  {link.icon}
                </a>
              ))}
            </div>
            
            {/* Navigation Links */}
            <div className="flex space-x-6 text-sm">
              <Link 
                to="/" 
                className="text-white/80 hover:text-white font-semibold transition-colors duration-200"
              >
                Home
              </Link>
              <Link 
                to="/services" 
                className="text-white/80 hover:text-white font-semibold transition-colors duration-200"
              >
                Services
              </Link>
              <Link 
                to="/contact" 
                className="text-white/80 hover:text-white font-semibold transition-colors duration-200"
              >
                Contact Us
              </Link>
            </div>
            
            {/* Copyright */}
            <div className="text-white/60 text-xs text-center md:text-right">
              &copy; {new Date().getFullYear()} Syltix. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
} 